import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"

const surveyRepliesListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, survey) => <>{survey?.id}</>,
    },
    {
      text: "Survey",
      dataField: "question.survey.name",
      formatter: (cellContent, survey) => <>{survey?.question?.survey?.name}</>,
    },
    {
      text: "User Name",
      dataField: "name",
      formatter: (cellContent, survey) => <>{survey?.name}</>,
    },
    {
      text: "User Emal",
      dataField: "email",
      formatter: (cellContent, survey) => <>{survey?.email}</>,
    },
    {
      text: "Question",
      dataField: "question.question",
      formatter: (cellContent, survey) => <>{survey?.question?.question}</>,
    },
    {
      text: "Answer",
      dataField: "answer",
      formatter: (cellContent, survey) => (
        <>{survey?.answer_id ? survey?.answer?.answer : survey?.answer_text}</>
      ),
    },
    {
      text: "Responded At",
      dataField: "created_at.date",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, survey) => (
        <>{getFormattedTime(survey?.created_at?.date)}</>
      ),
    },
  ]
}

export default surveyRepliesListColumns
